export const RECIPIENTS_DROPDOWN_MAX_HEIGHT = 352

export const QA_NAME_PREVIEW_MODAL = 'preview'

export const QA_NAME_FROM_FIELD = 'fromField'

export const QA_NAME_TO_FIELD = 'toField'

export const QA_NAME_SUBJECT_FIELD = 'subjectField'

export const QA_NAME_MESSAGE_FIELD = 'messageField'
